import {
  Button,
  ForwardIcon,
  IError,
  List,
  ListItem,
  LoadingOverlay,
  Vendors,
  useToast,
} from '@comptia-sso/core';
import { MouseEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// Config.
import { env } from 'config';

// Hooks.
import {
  useProfile,
  useRedirectToVendor,
  useTrackEvent,
  useTrackOdpEvent,
} from 'hooks';
import { useSierra } from '../../app/SierraContext';

// Styles.
import styles from '../../views/HomeView/HomeView.module.scss';

export const CertificationAccount = (): ReactElement => {
  const sierra = useSierra();
  const { t } = useTranslation();
  const [popToast] = useToast();
  const [profile] = useProfile();
  const [redirectToVendor, { isLoading: isRedirecting }] = useRedirectToVendor(
    profile?.id,
  );
  const trackEvent = useTrackEvent('Manage Your Certifications');
  const trackOdpEvent = useTrackOdpEvent();

  const handleEvent = (e: MouseEvent<HTMLElement>) => {
    const element = e.target as HTMLElement;
    trackEvent('Clicked', { label: element.innerText });
    trackOdpEvent('navigation', 'Launchpad Button', 'Manage Certifications');
  };

  return (
    <>
      <div id="certMetricsAccount" className={styles.card}>
        <div className={styles.content}>
          <h2>{t('CertificationAccount.Title')}</h2>
          <p>{t('CertificationAccount.Content')}</p>
          {env.FLAG_CERTMETRICS_ENABLED && profile?.compTIAId ? (
            <>
              {sierra.isEnabled() && (
                <>
                  <Button
                    className={styles.forwardButton}
                    onClick={async (e) => {
                      sierra.navigateToSierraRoute('certifications');
                    }}
                  >
                    {t('CertificationAccount.Button')}&nbsp;
                    <ForwardIcon />
                  </Button>
                  <Button
                    className={styles.forwardButton}
                    onClick={async (e) => {
                      sierra.navigateToSierraRoute('continuingeducation');
                    }}
                  >
                    {t('CertificationAccount.ButtonCe')}&nbsp;
                    <ForwardIcon />
                  </Button>
                </>
              )}
              {!sierra.isEnabled() && (
                <Button
                  className={styles.forwardButton}
                  onClick={async (e) => {
                    handleEvent(e);

                    try {
                      await redirectToVendor(Vendors.CertMetrics);
                    } catch (error) {
                      popToast(
                        (error as IError)?.message || t('Toast.Error.Default'),
                      );
                    }
                  }}
                >
                  {t('CertificationAccount.ButtonAcct')}&nbsp;
                  <ForwardIcon />
                </Button>
              )}
            </>
          ) : (
            <>
              <Button
                className={styles.forwardButton}
                link
                onClick={(e) => {
                  handleEvent(e);
                }}
                to="https://www.comptia.org/certifications"
              >
                {t('CertificationAccount.Button')}&nbsp;
                <ForwardIcon />
              </Button>
              <Button
                className={styles.forwardButton}
                link
                onClick={(e) => {
                  handleEvent(e);
                }}
                to="https://www.comptia.org/continuing-education"
              >
                {t('CertificationAccount.ButtonCe')}&nbsp;
                <ForwardIcon />
              </Button>
            </>
          )}
        </div>
      </div>
      <LoadingOverlay isOpen={isRedirecting} text={t('Loading.Default')} />
    </>
  );
};
